import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: ["geographicalOccupation"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["geographicalOccupation"],
        config: {
            headerName: getLocalizedString("plantPersonnel"),
            field: "Personal de planta",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["geographicalOccupation"],
        config: {
            headerName: getLocalizedString("region"),
            field: "Region",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["geographicalOccupation"],
        config: {
            headerName: getLocalizedString("provicia"),
            field: "Provincia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["geographicalOccupation"],
        config: {
            headerName: getLocalizedString("comuna"),
            field: "Comuna",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.geographicalStructure],
        config: {
            headerName: getLocalizedString("regionCode"),
            field: "Código de region",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.geographicalStructure],
        config: {
            headerName: getLocalizedString("region"),
            field: "Region",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.geographicalStructure],
        config: {
            field: "Código de provincia",
            headerName: getLocalizedString("provinceCode"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.geographicalStructure],
        config: {
            field: "Provincia",
            headerName: getLocalizedString("provicia"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.geographicalStructure],
        config: {
            field: "Código de comuna",
            headerName: getLocalizedString("communeCode"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.geographicalStructure],
        config: {
            field: "Comuna",
            headerName: getLocalizedString("comuna"),
            filter: "agSetColumnFilter",
        }
    },
]